/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumArticle.vue?vue&type=template&id=1b0bcd56&scoped=true&"
import script from "./ForumArticle.vue?vue&type=script&setup=true&lang=js&"
export * from "./ForumArticle.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ForumArticle.vue?vue&type=style&index=0&id=1b0bcd56&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0bcd56",
  null
  
)

export default component.exports